import React, { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

/**
 * Props interface for the ClientsOutlet component.
 * Currently empty as the component doesn't accept any props.
 * 
 * @interface ClientsOutletProps
 */
interface ClientsOutletProps {}

/**
 * A wrapper component that renders the nested routes for the clients section.
 * Uses React Router's Outlet component to render child routes.
 * 
 * @component
 * @returns {JSX.Element} The rendered child route component
 * 
 * @example
 * ```tsx
 * <ClientsOutlet />
 * ```
 */
const ClientsOutlet: FunctionComponent<ClientsOutletProps> = () => {
  return <Outlet />;
};

export default ClientsOutlet;
